import { FC } from "react";
import { Body } from "../../typography";

/**
 * The spacer tab component to render.
 */
export const SpacerTab: FC = () => {
  return (
    <li className="tab spacer">
      <span className="hotspot">
        <span className="content">
          <Body inline size="inherit" className="client-area">
            &nbsp;
          </Body>
        </span>
      </span>
    </li>
  );
};
